<template>
	<div class="popup" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">Добавить позицию</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__content">
				<ProductCategories v-model="positions" :showProducts="true"/>
			</div>
			<hr>
			<div class="popup__btns">
				<button class="btn btn--color" @click="$emit('close'), $emit('update:modelValue', this.positions)">Добавить</button>
			</div>
		</div>
	</div>
</template>
<script>
import ProductCategories from "@/components/blocks/ProductCategories.vue";

export default {
	name: 'AddPositionPopup',
	components: {ProductCategories},
	emits: ['update:modelValue', 'close'],
	props: {
		productGroups: {
			type: Array,
			default: () => []
		},
	},
	data() {
		return {
			positions: ''
		}
	},
}
</script>
